import { initializeApp } from 'firebase/app';
import { getAuth, indexedDBLocalPersistence, initializeAuth } from 'firebase/auth';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { Capacitor } from '@capacitor/core';

const firebaseConfig = {
  apiKey: "AIzaSyCc2ujdxmLDlOnvzJaBotM2VRpeKTKjVJk",
  authDomain: "scribe-b7e16.firebaseapp.com",
  projectId: "scribe-b7e16",
  storageBucket: "scribe-b7e16.firebasestorage.app",
  messagingSenderId: "106578839906",
  appId: "1:106578839906:web:6ee4f872031603e583443b",
  measurementId: "G-1GG37T3YPB",
};

const app = initializeApp(firebaseConfig);

export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);

// Analytics only runs on web (not in Capacitor native shell)
export const analyticsPromise = !Capacitor.isNativePlatform()
  ? isSupported().then(yes => yes ? getAnalytics(app) : null)
  : Promise.resolve(null);

export default app;
